import React from "react"
import { withTheme } from "emotion-theming"

const Close = ({ theme, colour }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path
      stroke={colour ? colour : theme.backgroundColor}
      strokeWidth="4"
      d="M1 32L32 1M1 1l31 31"
    />
  </svg>
)

export default withTheme(Close)
